document.addEventListener('DOMContentLoaded', () => {
    const isGermany = document.documentElement.lang === 'de-DE';

    if(!isGermany) return;

    const form = document.querySelector('#formclient');

    //skip mobile phone step in provided
    let mobileProvided = false;

    const handleSkipMobileStep = (event) => {
        const leadData = event.detail.leadData;
        
        if (mobileProvided || !leadData.Phone) return;

        const isMobile = window.libphonenumber.parsePhoneNumberFromString(leadData.Phone, 'DE').getType() == 'MOBILE';
        const pushKey = form.dataset.id + '-' + (form.dataset.offerType ? form.dataset.offerType : 'generic');

        isMobile && window.sessionLayer.leadHandler.push(pushKey, {
            MobilePhone: leadData.Phone
        });
        mobileProvided = true;
    }

    const handleExpressConsent = (event) => {
        const pushKey = form.dataset.id + '-' + (form.dataset.offerType ? form.dataset.offerType : 'generic');
        const currentStep = document.querySelectorAll('.Application .Step')[event.detail.index || 0];
        const mobileStep = currentStep.classList.contains('cc_phone--mobile') ? currentStep : false;
        
        if (!mobileStep) return;

        !event.detail.leadData.MobilePhone && window.sessionLayer.leadHandler.push(pushKey, {
            Express_written_consent__c: 'not set'
        });

        form.removeEventListener('submit', handleExpressConsent);
    };

    form && window.addEventListener('FormClientRendered', ()  => {
        form.addEventListener('submit', (event) => {
            handleSkipMobileStep(event)
            handleExpressConsent(event)
        })
    });
});